module.exports = {"Hello":"Hello DE","about_us":"Über"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/de-DE/de.json
// module id = E34H
// module chunks = 1